import {Card} from "../../../basic/card.tsx";
import {Check, Copy, Mail, Phone} from "lucide-react";
import {Button} from "../../../basic/button.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface ContactInformationProps {
    teamId?: string;
    userId?: string;
    copiedTeamId: boolean;
    copiedUserId: boolean;
    onCopyTeamId: () => void;
    onCopyUserId: () => void;
}

export function ContactInformation({
                                       teamId,
                                       userId,
                                       copiedTeamId,
                                       copiedUserId,
                                       onCopyTeamId,
                                       onCopyUserId
                                   }: ContactInformationProps) {
    const {t} = useTranslationWithKeys();

    return (
        <Card className="p-6 shadow-sm border-border/50">
            <h3 className="mb-4">{t('support.contactInformation')}</h3>
            <div className="space-y-4">
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <Phone className="h-4 w-4 text-primary"/>
                        <p>{t('support.phoneSupport')}</p>
                    </div>
                    <p className="text-muted-foreground mb-1">{t('support.phoneHours')}</p>
                    <a
                        href="tel:+41552207100"
                        className="text-primary hover:underline"
                    >
                        +41 55 220 71 00
                    </a>
                </div>

                <div className="pt-4 border-t">
                    <div className="flex items-center gap-2 mb-2">
                        <Mail className="h-4 w-4 text-primary"/>
                        <p>{t('support.emailSupport')}</p>
                    </div>
                    <p className="text-muted-foreground mb-1">{t('support.emailResponseTime')}</p>
                    <a
                        href="mailto:info@velasolaris.com"
                        className="text-primary hover:underline break-all"
                    >
                        info@velasolaris.com
                    </a>
                </div>

                <div className="pt-4 border-t">
                    <p className="mb-2">{t('support.accountInformation')}</p>
                    <div className="space-y-2">
                        <div className="flex items-center gap-2">
                            <code className="px-3 py-1.5 bg-muted rounded text-center flex-1">
                                {teamId || "-"}
                            </code>
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={onCopyTeamId}
                                disabled={!teamId}
                            >
                                {copiedTeamId ? <Check className="h-4 w-4"/> : <Copy className="h-4 w-4"/>}
                            </Button>
                        </div>
                        <div className="flex items-center gap-2">
                            <code className="px-3 py-1.5 bg-muted rounded text-center flex-1">
                                {userId || "-"}
                            </code>
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={onCopyUserId}
                                disabled={!userId}
                            >
                                {copiedUserId ? <Check className="h-4 w-4"/> : <Copy className="h-4 w-4"/>}
                            </Button>
                        </div>
                    </div>
                    <p className="text-muted-foreground mt-2">
                        {t('support.shareIdsDescription')}
                    </p>
                </div>
            </div>
        </Card>
    );
}